import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpClient, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoggingApiService } from '../services/logging-api.service';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth.service';
import { LoggingMessageService } from '../services/logging-message.service';
import { StorageService } from 'src/app/core/services/storage.service';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    private subscriptionKey: string;

    constructor(private http: HttpClient,
                private authService: AuthService,
                private msgLogger: LoggingMessageService,
                private logger: LoggingApiService,
                private storageService: StorageService) {
        this.subscriptionKey = environment.SubscriptionSelected;
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.msgLogger.debug('token.interceptor', 'intercept', this.storageService.getSubscription(), this.storageService.getSubscriptionsAvailable(), 'Token Intercept running', '');
        const user = this.authService.getTokenEmail();
        this.msgLogger.debug('token.interceptor', 'intercept', this.storageService.getSubscription(), this.storageService.getSubscriptionsAvailable(), 'Adding token to header', '');

        const useCookies = environment.UseCookies;
        const isLoggedIn = this.authService.isUserLoggedIn();
        if (isLoggedIn === true) {
           const subscription = this.storageService.getSubscription() ?? -1;
           this.msgLogger.info('token.interceptor', 'intercept', this.storageService.getSubscription(), this.storageService.getSubscriptionsAvailable(), `subscription:${subscription}`, '');

           if (useCookies === false) {
                const token = this.authService.getAccessToken();
                if (JSON.stringify(token) !== "{}") {
                    req = this.addToHeader(req, token, subscription.toString());
                }
            } else {
                    req = this.addSubscriptionToHeader(req, subscription.toString());
            }
        //    if (useCookies === false) {
        //         const token = this.authService.getAccessToken();
        //         if (JSON.stringify(token) !== "{}") {
        //           req = this.addToHeader(req, token, productSolution);
        //         }
        //    } else {
        //         req = this.addProductToHeader(req, productSolution);
        //    }
        } else {
            this.postWindowMessage();
        }
        return next.handle(req);
    }

    private addToHeader(req: HttpRequest<any>, token: any, subscription: string): HttpRequest<any> {
        req = req.clone({
            withCredentials: true,
            setHeaders: {
                Authorization: token,
                'subscription': subscription
            }
        });
        return req;
    }


    private postWindowMessage() {
        setTimeout(() => {
            window.parent.postMessage('logout:', '*');
        }, 0);
    }

    private addSubscriptionToHeader(req: HttpRequest<any>, subscription: string): HttpRequest<any> {
        req = req.clone({
            setHeaders: {
                'subscription': '-1'    //this.storageService.getSubscription()
            }
        });
        this.msgLogger.info('token.interceptor', 'addSubscriptionToHeader', this.storageService.getSubscription(), this.storageService.getSubscriptionsAvailable(), `Added subscription:${subscription}`, '');
        return req;
    }   
}
